import React, { FC } from 'react'

import { Box } from '@popmenu/common-ui'
import { useFullScreenStepperProgressStyles } from './FullScreenStepperProgressStyles'
import { FullScreenStepperProgressProps } from './FullScreenStepperProgressProps'

export const FullScreenStepperProgress: FC<FullScreenStepperProgressProps> = (props) => {
  const classes = useFullScreenStepperProgressStyles(props)
  return (
    <Box className={classes.track}>
      <Box className={classes.progress} />
    </Box>
  )
}
